import type { ModelContext } from "../../rdf/model";
import { listOntologies } from "../../rdf/model";
import type { DatasetDescriptor, TermSummary } from "../../rdf/types";

/**
 * Best-effort match from a registry dataset to the `owl:Ontology`
 * self-declaration term inside its own file(s) — the two don't always share
 * one exact IRI (e.g. BFO's `namespaceIri` is the shared OBO PURL prefix,
 * while its file declares itself at a more specific `.../obo/bfo.owl`), so
 * this matches by namespace prefix rather than requiring equality.
 */
export function findOntologyTerm(
  ctx: ModelContext,
  dataset: DatasetDescriptor,
): TermSummary | null {
  const strippedNamespace = dataset.namespaceIri.replace(/[/#]$/, "");
  return (
    listOntologies(ctx).find((term) => term.iri.startsWith(strippedNamespace)) ??
    null
  );
}
